module.exports = __webpack_public_path__ + "static/media/icon-clock.10d70dac.svg";